<template>
  <div></div>
</template>

<script>
import { loadRoute } from '@/helpers/page';
import store from '@/store';
import eventBus from 'vue-option-events';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  data: () => ({
    user: ''
  }),

  async created() {
    await this.getProfile();

    if (this.user && this.user.dashboard.mode && this.user.dashboard.page) {
      const { page, mode } = this.user.dashboard;
      const menuItem = await this.getMenu(page);
      this.$store.dispatch('page/setMain', page);
      await loadRoute({ page, mode, breadCrumbs: menuItem, dashboardNome: this.user.dashboard.page, target: 'page' });
      await eventBus.$emit(HANDLERS.ENABLE_FOOTER);
    }
  },

  methods: {
    getProfile() {
      this.user = store.getters['authentication/getUser'] || JSON.parse(sessionStorage.getItem('i4pro-portal')).authentication.user;
    },

    getMenu(page) {
      let menu = store.getters['menu/getMenu'];

      let result = '';

      if (menu.length == 0) {
        menu = this.user.userMenu;
      }

      for (let item in menu) {
        if (menu[item].children) {
          for (let itemChildren in menu[item].children) {
            let forItem = menu[item].children[itemChildren];
            //achar item no 2º nivel
            if (forItem.page == page) {
              result = forItem;
            }
            //achar item no 3º nivel
            else if (forItem.children) {
              for (let itemChildren2 in forItem.children) {
                let itemFor = forItem.children[itemChildren2];
                if (itemFor.page) {
                  if (itemFor.page == page) {
                    result = itemFor;
                  }
                }
              }
            }
          }
        }
      }

      return result;
    }
  }
};
</script>
